<h1 class="confirmation-message-heading" mat-dialog-title>{{ title }}</h1>
@for (i of files; track i) {
  <mat-dialog-content class="mat-dialog-content-no-heading">
    @if (i) {
      <audio #audio controls>
        <source [src]="i?.file.fileToken | fileUrl" (error)="onFileNotFound($event)" />
      </audio>
    }
    @if (fileNotFound) {
      <mat-error matError>Failed to load audio file</mat-error>
    }
  </mat-dialog-content>
}
<mat-dialog-actions>
  @if (!fileNotFound) {
    <button mat-stroked-button color="primary" (click)="downloadRecording(files[0].file)">
      Download
    </button>
  }
  <span style="flex: 1 1 auto"></span>
  @if (canDeleteCallRecording) {
    <button
      type="button"
      mat-stroked-button
      color="primary"
      tabindex="-1"
      (click)="onDeleteClick()"
      >Delete</button
      >
    }
    <button type="button" mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
  </mat-dialog-actions>
